import React from 'react';
import { Link } from 'react-router-dom';
import imageDenied from 'assets/img/404.svg';
import imageDeniedMob from 'assets/img/404-mobile.svg';
import styles from './NotFoundPage.module.less';

export default function NotFoundPage() {
  return (
    <div className="scroll-box">
      <div className={styles.notFoundPage}>
        <div className={styles.imageBox}>
          <div className={styles.imageWrapp}>
            <img
              className={styles.image}
              src={imageDenied}
              alt="page not found"
            />
            <img
              className={styles.imageMob}
              src={imageDeniedMob}
              alt="page not found"
            />
          </div>
        </div>
        <div className={styles.titleBox}>
          <h1 className={styles.title}>
            Oops. Looks like this page does not exist.
          </h1>
          <h2 className={styles.subTitle}>
            You can return to the <Link to="/">homepage</Link> or contact us
            through live chat.
          </h2>
        </div>
      </div>
    </div>
  );
}
